import { ReactElement } from "react";
import { createPortal } from "react-dom";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./DeleteFlowsheetModal.module.scss";

interface IDeleteFlowsheetModalProps {
    onDelete: () => void;

    onClose?: () => void;
}

function DeleteFlowsheetModal({ onDelete, onClose }: Readonly<IDeleteFlowsheetModalProps>): ReactElement {
    const { getText } = useTranslation();

    return (
        createPortal(
            <Modal
                dataCy="delete-flowsheet-modal"
                width={428}
                title={getText("Flowsheets_WarningLabel")}
                footer={(
                    <div className={styles.deleteFlowsheetModalFooter}>
                        <ButtonGroup spacing="sm">
                            <ButtonControl
                                variant="neutral"
                                onClick={() => onClose?.()}
                                label={cacheStore.GetString("Flowsheets_GoBackLabel")}
                            />
                            <ButtonControl
                                variant="brand"
                                dataCy="delete-flowsheet-modal-ok-button"
                                onClick={() => onDelete()}
                                label={cacheStore.GetString("OKLabel")}
                            />
                        </ButtonGroup>
                    </div>
                )}
                onClose={() => onClose?.()}
            >
                <div className={styles.messageContainer}>
                    <p>{getText("Flowsheets_DeleteConfirmation_YouAreAboutToDeleteFlowsheetMessage")}</p>
                    <p>{getText("Flowsheets_DeleteConfirmation_AreYouSureMessage")}</p>
                </div>
            </Modal>,
            document.body
        ));
}

export {
    DeleteFlowsheetModal
};
